<!--
일괄기능-샘플작업
------------------------------------

-->
<template>
<div>
    <button 
        class="uk-button uk-button-primary"
        type="button"
        :disabled="disabled"

        href="#modal-full" uk-toggle
    >
        샘플작업
    </button>

    <div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
            <div class="uk-padding" uk-height-viewport>

                <!-- 대기화면 -->
                <div v-show="jobState === 'ready'" class="">
                    <p class="uk-text-center uk-text-primary uk-text-large">
                        "작업설명"
                    </p>

                    <div>
                        <button 
                            class="uk-button uk-button-primary"
                            type="button"
                            v-on:click="jobState='doing'"
                        >
                            작업시작
                        </button>
                    </div>
                    
                </div>
                

                <!-- 실행중 -->
                <div v-show="jobState === 'doing'" class="">
                    <p class="uk-text-center uk-text-danger uk-text-large">
                        "작업이 종료될때까지 브라우저를 닫지마세요"
                    </p>

                    <div>
                        <button 
                            class="uk-button uk-button-primary"
                            type="button"
                            v-on:click="jobState='done'"
                        >
                            완료처리
                        </button>
                    </div>
                </div>

                <!-- 완료 -->
                <div v-show="jobState === 'done'" class="">
                    <p class="uk-text-center uk-text-primary uk-text-large">
                        "작업이 완료되었습니다. 브라우저를 닫아도 좋습니다."
                    </p>

                    <div>
                        <button 
                            class="uk-button uk-button-default uk-button-large"
                            type="button"
                            v-on:click="refreshPage()"
                        >
                            현재 페이지 새로고침
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
</div>
    
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object
        },
        data: function () {
            return {
                /**
                 * 현재 작업진행상태 
                 *  - ready : 작업 대기중
                 *  - doing : 진행중
                 *  - done : 완료
                 */
                jobState: 'ready'
            };
        },
        computed: {
            // 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            }
        },
        methods: {
            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>